var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 16.375C4.07663 16.375 3.55245 16.375 3.13896 16.2037C2.58765 15.9754 2.14963 15.5374 1.92127 14.986C1.75 14.5726 1.75 14.0484 1.75 13V5.35C1.75 4.08988 1.75 3.45982 1.99524 2.97852C2.21095 2.55516 2.55516 2.21095 2.97852 1.99524C3.45982 1.75 4.08988 1.75 5.35 1.75H13C14.0484 1.75 14.5726 1.75 14.986 1.92127C15.5374 2.14963 15.9754 2.58765 16.2037 3.13896C16.375 3.55245 16.375 4.07663 16.375 5.125M13.225 24.25H20.65C21.9101 24.25 22.5402 24.25 23.0215 24.0048C23.4448 23.789 23.789 23.4448 24.0048 23.0215C24.25 22.5402 24.25 21.9101 24.25 20.65V13.225C24.25 11.9649 24.25 11.3348 24.0048 10.8535C23.789 10.4302 23.4448 10.086 23.0215 9.87024C22.5402 9.625 21.9101 9.625 20.65 9.625H13.225C11.9649 9.625 11.3348 9.625 10.8535 9.87024C10.4302 10.086 10.086 10.4302 9.87024 10.8535C9.625 11.3348 9.625 11.9649 9.625 13.225V20.65C9.625 21.9101 9.625 22.5402 9.87024 23.0215C10.086 23.4448 10.4302 23.789 10.8535 24.0048C11.3348 24.25 11.9649 24.25 13.225 24.25Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.02b807a3891b1fdfc4082776e5ce8872.svg";
export { ForwardRef as ReactComponent };